<script lang="ts" setup>
import EventPublicWrapper from "../EventPublic/EventPublicWrapper.vue";
import EventInformationMap from "@/Pages/EventPublic/Components/EventInformationMap.vue";
import { Head } from "@inertiajs/vue3";

interface Props {
    event: object;
    canRegisterForEvent: boolean;
}

// const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
    <EventPublicWrapper>
        <Head>
            <title>Event map: {{ $page.props.event.name }}</title>

            <meta
                property="og:title"
                head-key="og:title"
                :content="`Event Map: ${$page.props.meta_event_name}`"
            />

            <meta
                name="robots"
                content="noindex, follow"
            />
        </Head>
        <template #map>
            <EventInformationMap
                :is-map-page="true"
                class="content-full-screen-height-mt-4 min-h-[50vh] flex-1 rounded-lg bg-white shadow-lg"
            />
        </template>
    </EventPublicWrapper>
</template>
